export const CTA_REQUEST_TIMEOUT_MS = 5000;

/** Фейл-открыт: и таймаут, и отказ дают null, чтобы клик по CTA не остался без результата.
    abort по таймауту обязателен — иначе RTK Query продолжит держать isFetching и кнопка не разблокируется. */
export const withRequestTimeout = <T>(request: Promise<T> & { abort(): void }, timeoutMs: number): Promise<T | null> =>
  new Promise<T | null>(resolve => {
    const timer = setTimeout(() => {
      request.abort();
      resolve(null);
    }, timeoutMs);

    const settle = (value: T | null) => {
      clearTimeout(timer);
      resolve(value);
    };

    request.then(settle).catch(() => settle(null));
  });
